type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const InstagramRepostIcon = (props: Props) => {
  const {
    width = '24',
    height = '24',
    viewBox = '0 0 24 24',
    fillColor = 'currentColor',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="m17 2 4 4-4 4M3 11V9a4 4 0 0 1 4-4h14m-14 18-4-4 4-4M21 13v2a4 4 0 0 1-4 4H3"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InstagramRepostIcon;
